<mat-toolbar color="primary" class="header">
  <div class="cummins-logo-container">
    <a routerLink="/"><div class="cummins-logo"></div></a>
    <div class="header-text">
      <!-- {{ headerText }}
      <span class="version-text">{{ version }}</span> -->
      <!-- <span class="version-text" *ngIf="typeOf(ver) === 'string'">{{
        ver
      }}</span> -->
      {{ headerText && headerText.trim() ? headerText : 'Omni Dashboard' }}

    <span class="version-text" *ngIf="typeOf(ver) === 'string'">{{ ver }}

  </span>
    </div>
  </div>
  <span class="spacer"></span>
  <div class="right-section">
    <!-- <span class="welcome-text">Hi {{ user }}</span> -->
    <span class="welcome-text">
      Hi {{ userProfile?.firstName }} {{ userProfile?.lastName }}</span
    >
    <a class="icon disabled" data-title="Feedback">
      <mat-icon class="sett-icon" (click)="openFeedback()"
        >feedback</mat-icon
      ></a
    >
    <a class="icon"
      ><mat-icon class="sett-icon" (click)="openDialog()"
        >video_library</mat-icon
      ></a
    >

    <a class="icon" [matMenuTriggerFor]="menu">
      <mat-icon class="sett-icon">help</mat-icon>
    </a>

    <a class="icon" id="accountSettings" data-title="logout">
      <mat-icon class="sett-icon" (click)="onLogout($event)"
        >power_settings_new</mat-icon
      ></a
    >
  </div>
</mat-toolbar>
<mat-menu #menu="matMenu" class="menuStyle">
  <button mat-menu-item>
    <a style="color: white" target="_blank" href="/assets/Help.pdf">
      <mat-icon style="color: white">picture_as_pdf</mat-icon> Help
      Documentation
      <i class="bi bi-download"></i>
    </a>
  </button>
</mat-menu>
